export default function ({ app }, inject) {
  const dadataApi = {
    async suggestAddress(query) {
      const url =
        'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address'
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          // Authorization: `Token ${process.env.DADATA_API_KEY}`,
          Authorization: 'Token 5a53a3028f69d078de48fa57a1a6f36ba8b52fbb',
        },
        body: JSON.stringify({ query }),
      })
      return await response.json()
    },
  }
  inject('dadata', dadataApi)
}
